import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { useLocation } from 'react-router-dom';
import { fetchAppDetails } from '../../actions/AppActions';
import { useFetchAccounts } from '../../hooks/queries/accounts/useFetchAccounts';
import { getAppDetails, getAppDetailsStatus } from '../../selectors/AppSelectors';
import { isValidClientId } from '../../utils/authUtils';
import { getAuthorizationRequestInfo } from '../../utils/urls';
import AuthorizeHeader from '../AuthorizeHeader';
import ConnectAppInfo from '../ConnectAppInfo';
import LoadingStateWrapper from '../LoadingStateWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectAppContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const appDetails = useSelector(getAppDetails);
  const appDetailsStatus = useSelector(getAppDetailsStatus);
  const authUrlInfo = getAuthorizationRequestInfo(location.search);
  const clientId = authUrlInfo.clientId;
  const clientIdIsValid = isValidClientId(clientId);
  const {
    data: accounts,
    requestStatus: accountsFetchStatus
  } = useFetchAccounts(clientId);
  useEffect(() => {
    if (clientIdIsValid) {
      dispatch(fetchAppDetails(clientId)).catch(e => Raven.captureException(e));
    }
  }, [dispatch, clientId, clientIdIsValid]);
  const renderErrorAlert = message => {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "AUTH_PAGE_LOAD_ERROR",
      children: /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "oauth.authorization.errorSubHeader"
        }),
        type: "danger",
        marginBlock: "400",
        children: message
      })
    });
  };
  if (!clientIdIsValid) {
    return /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "center",
      direction: "column",
      children: renderErrorAlert( /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.errors.BAD_CLIENT_ID"
      }))
    });
  }
  return /*#__PURE__*/_jsx(LoadingStateWrapper, {
    status: [appDetailsStatus, accountsFetchStatus],
    showLoadingIfUnfetched: true,
    error: /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "center",
      direction: "column",
      children: renderErrorAlert( /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.errors.SERVER_ERROR"
      }))
    }),
    children: appDetailsStatus.succeeded && accountsFetchStatus.succeeded && appDetails && accounts && /*#__PURE__*/_jsx(NavMarker, {
      name: "AUTH_PAGE_LOAD",
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        justify: "center",
        direction: "column",
        children: [/*#__PURE__*/_jsx(AuthorizeHeader, {
          providerName: appDetails.name
          // App logo
          ,
          providerIconUrl: appDetails.iconUrl || undefined
        }), /*#__PURE__*/_jsx(ConnectAppInfo, {
          providerName: appDetails.name,
          providerId: Number(appDetails.id),
          providerDomain: appDetails.isVerified && appDetails.domain ? appDetails.domain : undefined,
          accounts: accounts
        })]
      })
    })
  });
};
export default ConnectAppContainer;